import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Footer from './components/footer/Footer';
import Navbar from './components/navbar/Navbar';
import SocialLinks from './components/socialLinks/SocialLinks';
import Home from './pages/home/Home';
import AboutCompany from './pages/aboutCompany/AboutCompany';
import ScrollTop from './components/scrollTop/ScrollTop';
import Services from './pages/services/Services';
import ContactUs from './pages/contactUs/ContactUs';
import WhyUs from './pages/whyUs/WhyUs';

function App() {
  
  return (
    <div className="App">
      <BrowserRouter>

        <Navbar />
        <ScrollTop />
        <SocialLinks />

        <Routes>
          <Route path='/' element={<Home />}></Route>
          <Route path='/about' element={<AboutCompany />}></Route>
          <Route path='/services' element={<Services />}></Route>
          <Route path='/whyUs' element={<WhyUs />}></Route>
          <Route path='/contact' element={<ContactUs />}></Route>
        </Routes>

        <Footer />

      </BrowserRouter>

    </div>
  );
}

export default App;
